import gql from 'graphql-tag';

export default gql`
query getGroupSettings($groupId: Int!) {
  groups_by_pk(group_id: $groupId) {
    settings
  }
}
`;
